import React, { useCallback } from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import GenericMasonry from "src/components/GenericMasonry";
import { replaceImageWidth } from "src/components/BannerImagePicker/BannerImagePicker.util";
import { copywriting } from "../ImagePicker.config";
import { unsplashSearch } from "../ImagePicker.util";

const UnsplashTab = ({
  onSelect,
  scrollContainer = "parent",
  imageWidth = null,
  leadingItems = [],
  onClickLeadingItems,
  searchTermRef,
  avatarMode = false,
}) => {
  const normalizeItem = useCallback(
    (item) => {
      return {
        id: item.id,
        src: imageWidth
          ? replaceImageWidth(get(item, "urls.thumb"), imageWidth)
          : get(item, "urls.thumb"),
        alt: get(item, "alt_description"),
        author: get(item, "user.name"),
        authorLink: get(item, "user.links.html"),
        color: get(item, "color"),
        width: get(item, "width", 1),
        height: get(item, "height", 1),
        data: item,
      };
    },
    [imageWidth]
  );

  const fetchItems = useCallback(
    async (page, limit, searchTerm) => {
      const { data, error } = await unsplashSearch(searchTerm, page + 1);

      if (error) {
        throw error;
      }

      return {
        data: data?.map(normalizeItem),
        error,
        hasMore: !!data?.length,
      };
    },
    [normalizeItem]
  );

  return (
    <GenericMasonry
      searchTermRef={searchTermRef}
      onSelectionChange={onSelect}
      searchable
      fetchItems={fetchItems}
      searchLabel={copywriting.ATTRIBUTION_LABEL}
      searchPlaceholder={copywriting.SEARCH_PLACEHOLDER}
      searchErrorText={copywriting.SEARCH_ERROR}
      scrollContainer={scrollContainer}
      leadingItems={leadingItems}
      onClickLeadingItems={onClickLeadingItems}
      avatarMode={avatarMode}
    />
  );
};

UnsplashTab.propTypes = {
  onSelect: PropTypes.func.isRequired,
  scrollContainer: PropTypes.string,
  imageWidth: PropTypes.number,
  leadingItems: PropTypes.arrayOf(PropTypes.object),
  onClickLeadingItems: PropTypes.func,
  searchTermRef: PropTypes.object,
  avatarMode: PropTypes.bool,
};

export default UnsplashTab;
